export const GIGRoutes = {
    ROOT: "/gig",
    ACTIVATION: "/gig/activation",
    PRECONTRACT: "/gig/precontract",
    SUCCESS: "/gig/success",
    SIGNING: "/gig/signing"
};



// WEBPACK FOOTER //
// ./src/components/gig/GIGRoutes.tsx